import { render, staticRenderFns } from "./RegisterModal.vue?vue&type=template&id=4f4d933d"
import script from "./RegisterModal.vue?vue&type=script&lang=js"
export * from "./RegisterModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {ControllerRegister: require('/home/node/app/node_modules/@gauss/cms-core/lib/components/controllers/user/ControllerRegister.js').default})
